import React, { Component } from "react";
import { Link, Redirect } from "react-router-dom";
import "./App.css";
import { AiOutlineSend } from "react-icons/ai";
import Axios from "axios";
import Header3 from "./components/Header3";
import Header_ from "./components/Header";
import Header from "./layouts/Header";
class Budget extends Component {
  constructor(props) {
    super(props);
    this.state = {
      vvip: 0,
      vip: 0,
      general: 0,
      priceOne: 0,
      priceTwo: 0,
      priceThree: 0,
      calResults: "",
    };

    this.handleVVIP = this.handleVVIP.bind(this);
    this.handleVIP = this.handleVIP.bind(this);
    this.handleGeneral = this.handleGeneral.bind(this);
    this.handlePriceOne = this.handlePriceOne.bind(this);
    this.handlePriceTwo = this.handlePriceTwo.bind(this);
    this.handlePriceThree = this.handlePriceThree.bind(this);
    this.handleCalculation = this.handleCalculation.bind(this);
  }

  handleVVIP(event) {
    this.setState({ vvip: event.target.value });
  }

  handleVIP = (event) => {
    this.setState({ vip: event.target.value });
  };

  handleGeneral = (event) => {
    this.setState({ general: event.target.value });
  };

  handlePriceOne = (event) => {
    this.setState({ priceOne: event.target.value });
  };

  handlePriceTwo = (event) => {
    this.setState({ priceTwo: event.target.value });
  };

  handlePriceThree = (event) => {
    this.setState({ priceThree: event.target.value });
  };

  handleCalculation() {
    const vvip = this.state.vvip;
    const vip = this.state.vip;
    const general = this.state.general;
    const priceone = this.state.priceOne;
    const pricetwo = this.state.priceTwo;
    const pricethree = this.state.priceThree;

    if (vvip !== "" && priceone === "") {
      this.setState({ calResults: "VVIP tickets expects ticket price value" });
    } else if (vvip === "" && priceone !== "") {
      this.setState({
        calResults: "VVIP ticket price expects a value of Number Of Ticket",
      });
    } else if (vip !== "" && pricetwo === "") {
      this.setState({ calResults: "VIP tickets expects ticket price value" });
    } else if (vip === "" && pricetwo !== "") {
      this.setState({
        calResults: "VIP ticket price expects a value of Number Of Ticket",
      });
    } else if (general !== "" && pricethree === "") {
      this.setState({
        calResults: "General tickets expects ticket price value",
      });
    } else if (general === "" && pricethree !== "") {
      this.setState({
        calResults: "General ticket price expects a value of Number Of Ticket",
      });
    } else {
      let { perone, pertwo, perthree } = 0;
      if (parseInt(priceone) > 200) {
        perone = 0.035;
      } else {
        perone = 0.035;
      }
      const calVVIP = priceone * perone;
      const amountOne = calVVIP * vvip;

      if (parseInt(pricetwo) > 200) {
        pertwo = 0.035;
      } else {
        pertwo = 0.035;
      }

      const calVIP = pricetwo * pertwo;
      const amountTwo = calVIP * vip;

      if (parseInt(pricethree) > 200) {
        perthree = 0.035;
      } else {
        perthree = 0.035;
      }

      const calGen = pricethree * perthree;
      const amountThree = calGen * general;

      let total = amountOne + amountTwo + amountThree;
      let totalA = total.toFixed(2);

      function formatToRand(amount) {
        return new Intl.NumberFormat("en-ZA", {
          style: "currency",
          currency: "ZAR",
        })
          .format(amount)
          .replace(/\s/g, "");
      }

      this.setState({
        calResults: "Your estimated budget is " + formatToRand(totalA),
      });
    }
  }

  render() {
    document.title =
      "Calculate how much you are willing to spend to sell tickets on Karamale";
    let btn = "";

    if (
      localStorage.getItem("businessname") === null &&
      localStorage.getItem("accounttype") === null
    ) {
      btn = (
        <Link to="/organiser-registration" className="text-underline-none">
          <div className="create-account-btn text-center">Get started</div>
        </Link>
      );
    } else {
      btn = (
        <Link
          to={{ pathname: "addevent", state: { prevpage: "budget" } }}
          className="text-underline-none"
        >
          <div className="create-account-btn text-center">Create event</div>
        </Link>
      );
    }
    return (
      <div className="view">
        {localStorage.getItem("businessname") !== null &&
        localStorage.getItem("accounttype") !== null ? (
          <Header3 />
        ) : (
          <Header />
        )}

        <div className="container mt-5">
          <div className="row justify-content-center align-self-center">
            <div className="row align-self-center justify-content-center">
              {/* <div className="log-title text-center col-12 mt-4">
                <img src="https://karamale.com/karamale.png" width="170" />
              </div> */}
              <div
                className="text-footer text-center mb-2 mt-5 col-12 category-name-heading"
                style={{
                  fontSize: 18,
                  color: "#4d4d4f",
                  textTransform: "none",
                }}
              >
                Ready to start selling on Karamale? Use the calculator to plan
                your budget.
              </div>
              <div className="col-lg-5 mb-4  pl-2 pr-2">
                <div className="BoxDashboardContainer w-100 col-12 mb-4 pl-3 pr-3">
                  <div className="row">
                    <div className="col-12 p-0">
                      <span>
                        <h4>Calculator</h4>
                      </span>
                    </div>
                    <div className="col-12 pl-1 pr-1">
                      <span className="">VVIP</span>{" "}
                    </div>
                    <div className="col-12 col-lg-6 col-md-6 col-sm-6 mb-4 pl-1 pr-1">
                      <label className="small-details">Number of tickets</label>
                      <input
                        type="number"
                        min={0}
                        required
                        placeholder="If applicable"
                        value={this.state.vvip}
                        onChange={this.handleVVIP}
                        className="edit-input"
                      />
                    </div>
                    <div className="col-12 col-lg-6 col-md-6 col-sm-6 mb-4 pl-1 pr-1">
                      <label className="small-details">Price per ticket</label>
                      <input
                        type="number"
                        min={0}
                        required
                        placeholder="Example: R550"
                        value={this.state.priceOne}
                        onChange={this.handlePriceOne}
                        className="edit-input"
                      />
                    </div>
                    <br />
                    <br />

                    <div className="col-12 pl-1 pr-1">
                      <span className="">VIP</span>{" "}
                    </div>
                    <div className="col-12 col-lg-6 col-md-6 col-sm-6 mb-4 pl-1 pr-1">
                      <label className="small-details">Number of tickets</label>
                      <br />
                      <input
                        type="number"
                        min={0}
                        name="phone"
                        required
                        placeholder="If applicable"
                        value={this.state.vip}
                        onChange={this.handleVIP}
                        className="edit-input"
                      />
                    </div>

                    <div className="col-12 col-lg-6 col-md-6 col-sm-6 mb-4 pl-1 pr-1">
                      <label className="small-details">Price per ticket</label>
                      <br />
                      <input
                        type="number"
                        min={0}
                        required
                        placeholder="Example: R150"
                        value={this.state.priceTwo}
                        onChange={this.handlePriceTwo}
                        className="edit-input"
                      />
                    </div>

                    <div className="col-12 pl-1 pr-1">
                      <span className="">General</span>{" "}
                    </div>
                    <div className="col-12 col-lg-6 col-md-6 col-sm-6 mb-4 pl-1 pr-1">
                      <label className="small-details">Number of tickets</label>
                      <br />
                      <input
                        type="number"
                        min={0}
                        name="email"
                        required
                        placeholder="If applicable"
                        value={this.state.general}
                        onChange={this.handleGeneral}
                        className="edit-input"
                      />
                    </div>

                    <div className="col-12 col-lg-6 col-md-6 col-sm-6 mb-4 pl-1 pr-1">
                      <label className="small-details">Price per ticket</label>
                      <br />
                      <input
                        type="number"
                        min={0}
                        required
                        placeholder="Example: R100"
                        value={this.state.priceThree}
                        onChange={this.handlePriceThree}
                        className="edit-input"
                      />
                    </div>
                  </div>
                  <div className="mb-3 msg-success mt-3">
                    {this.state.calResults}
                  </div>

                  <div className="col-12 response textMedium">
                    {this.state.response}
                  </div>
                  <button
                    onClick={this.handleCalculation}
                    className="mb-3 w-100"
                  >
                    Calculate
                  </button>
                  {/* <label className="small-details text-12">
                    This budget calculation is based on adult tickets only. Kids
                    aren't included yet, but will be in the campaign setup.
                  </label> */}

                  <div className="horizontal-line"></div>

                  {btn}
                </div>
                <div className=" BoxDashboardContainer col-12 w-100 mb-0 pl-0 pr-0">
                  <div className="row">
                    <div className="col-lg-12">
                      Be in control of your <span className="">Budget</span>.
                      Choose what you spend
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-lg-7 pl-2 pr-2">
                <div className=" BoxDashboardContainer w-100 col-12 mb-4 pl-1 pr-1">
                  <div className="row">
                    <div className="col-lg-12">
                      <span className="">Digital tickets</span>
                      <br />
                      Budget is calculated at <span className="">3.5%</span>
                      <br />
                      <br />
                      Tickets are instantly delivered to the customer's Karamale
                      account after a successful purchase. Within two minutes,
                      they'll see a full breakdown of their tickets — including
                      category, admissions, and unique ticket numbers —
                      displayed in a scannable QR code format
                      <br />
                      <br />
                      Use the Budget Calculator on the left to set how much
                      you're ready to invest in selling your tickets on
                      Karamale. It helps you plan smarter and reach more buyers
                      without overspending.
                      <br />
                      <br />
                      Raise your budget on your terms. Anytime, anywhere. You're
                      in control.
                      <br />
                      <br />
                      Every time a customer buys your ticket, Karamale deducts a
                      3.5% service fee directly from your campaign budget —
                      that's the only amount you'll ever pay us. The rest of
                      your ticket sales go entirely to you. When you request a
                      payout, a small payout processing fee applies, which
                      you'll see clearly listed on the payout page.
                    </div>
                  </div>
                </div>

                <div className=" BoxDashboardContainer w-100 col-12 mb-4 p-0">
                  <div className="row">
                    <div className="col-lg-12 p-0">
                      <div style={styles.container}>
                        <h4 style={styles.heading}>
                          💻 Karamale Online Ticket Pricing
                        </h4>

                        <table style={styles.table}>
                          <thead>
                            <tr style={styles.headerRow}>
                              <th style={styles.th}>Item</th>
                              <th style={styles.th}>Details</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <td style={styles.td}>Service Fee</td>
                              <td style={styles.td}>
                                3.5% — deducted from your campaign budget
                              </td>
                            </tr>
                            <tr>
                              <td style={styles.td}>Buyer Booking Fee</td>
                              <td style={styles.td}>
                                A small booking fee is charged to customers at
                                checkout
                              </td>
                            </tr>
                            <tr>
                              <td style={styles.td}>Payment Processing</td>
                              <td style={styles.td}>
                                Included — no extra gateway or merchant charges
                              </td>
                            </tr>
                            <tr>
                              <td style={styles.td}>Payout Fee</td>
                              <td style={styles.td}>
                                Small fee applies — transparently shown on the{" "}
                                <strong>Payouts</strong> page
                              </td>
                            </tr>
                            <tr>
                              <td style={styles.td}>Hidden Costs</td>
                              <td style={styles.td}>
                                None — all costs are covered by your budget or
                                shown to the buyer
                              </td>
                            </tr>
                            <tr>
                              <td style={styles.td}>Budget Control</td>
                              <td style={styles.td}>
                                You manage your spend upfront — adjust anytime
                                with full transparency ✅
                              </td>
                            </tr>
                          </tbody>
                        </table>

                        <p style={styles.footer}>
                          💬 <strong>Only your campaign budget is used</strong>{" "}
                          to cover Karamale's service fee — everything else is
                          clearly displayed to you and your buyers.
                        </p>
                      </div>
                      <div
                        className="pricing-table-container"
                        style={{
                          maxWidth: "600px",
                          margin: "0 auto",
                          fontFamily: "sans-serif",
                        }}
                      >
                        <h4
                          style={{
                            textAlign: "left",
                            marginBottom: "1.5rem",
                          }}
                        >
                          🎟️ Physical Ticket Options
                        </h4>

                        <table
                          style={{ width: "100%", borderCollapse: "collapse" }}
                        >
                          <thead>
                            <tr style={{ backgroundColor: "#f5f5f5" }}>
                              <th style={th}>Option</th>
                              <th style={th}>What You Get</th>
                              <th style={th}>Cost Per Ticket</th>
                              <th style={th}>Deducted From Budget?</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <td style={td}>Self-Print</td>
                              <td style={td}>
                                Download tickets and print them yourself
                              </td>
                              <td style={td}>R1.00</td>
                              <td style={td}>✅ Yes</td>
                            </tr>
                            <tr>
                              <td style={td}>Download + Prints by Karamale</td>
                              <td style={td}>
                                We download & print the tickets for you
                              </td>
                              <td style={td}>R3.50</td>
                              <td style={td}>✅ Yes</td>
                            </tr>
                          </tbody>
                        </table>

                        <p
                          style={{
                            marginTop: "1rem",
                            fontStyle: "italic",
                            fontSize: "0.95rem",
                          }}
                        >
                          💬 No extra invoicing, no hidden fees — your ticket
                          printing costs are automatically managed through your
                          campaign budget.
                        </p>
                      </div>
                      <p></p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
const th = {
  border: "1px solid #ddd",
  padding: "12px",
  textAlign: "left",
  fontWeight: "bold",
};

const td = {
  border: "1px solid #ddd",
  padding: "12px",
  verticalAlign: "top",
};

const styles = {
  container: {
    maxWidth: "720px",
    margin: "0 auto",
    fontFamily: "Arial, sans-serif",
    padding: "1rem",
  },
  heading: {
    textAlign: "left",
    marginBottom: "1.5rem",
  },
  table: {
    width: "100%",
    borderCollapse: "collapse",
  },
  headerRow: {
    backgroundColor: "#f5f5f5",
  },
  th: {
    border: "1px solid #ccc",
    padding: "12px",
    textAlign: "left",
    fontWeight: "bold",
  },
  td: {
    border: "1px solid #ccc",
    padding: "12px",
    verticalAlign: "top",
  },
  footer: {
    marginTop: "1rem",
    fontStyle: "italic",
    fontSize: "0.95rem",
  },
};

export default Budget;
